import {OptionMap} from "@/components/archive/Filtering/utils"

/**
 * Extracts and validates participant profile IDs from filters
 * Collects both profile_ids and auth_user_id for comprehensive matching
 *
 * @param filters - Array of filter objects
 * @returns Array of unique and validated profile IDs
 */
export const extractParticipantProfileIds = (
  filters: OptionMap[]
): string[] => {
  try {
    // Get all contributor filters
    const contributorFilters = filters.filter((f) => f.type === "contributors")

    if (contributorFilters.length === 0) {
      return []
    }

    // Extract profile_ids and auth_user_id from contributors for searching
    const profileIds = contributorFilters.flatMap((f) => {
      if (!f.value.contributors || !Array.isArray(f.value.contributors)) {
        // Skip invalid contributor entries
        return []
      }

      // Collect both profile_ids and auth_user_id
      return f.value.contributors.flatMap((c) => {
        const allIds = []

        // Add profile_ids if available
        if (c.profile_ids && Array.isArray(c.profile_ids)) {
          allIds.push(
            ...c.profile_ids.filter(
              (id) => id && id !== "undefined" && id !== "null"
            )
          )
        }

        // Add auth_user_id if available (can be used as profile_id in some cases)
        if (
          c.auth_user_id &&
          c.auth_user_id !== "undefined" &&
          c.auth_user_id !== "null"
        ) {
          allIds.push(c.auth_user_id)
        }

        return allIds
      })
    })

    // Remove duplicates and validate IDs
    const uniqueIds = [...new Set(profileIds)].filter(
      (id) => id && id !== "undefined" && id !== "null" && id.length > 5 // Basic validation
    )

    return uniqueIds
  } catch (error) {
    console.error("Error processing contributor filters:", error)
    return []
  }
}
